import _objectSpread from "/Users/mtsiang/Documents/inwave-stack/ui/react-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/mtsiang/Documents/inwave-stack/ui/react-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/mtsiang/Documents/inwave-stack/ui/react-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/mtsiang/Documents/inwave-stack/ui/react-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/mtsiang/Documents/inwave-stack/ui/react-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/mtsiang/Documents/inwave-stack/ui/react-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/mtsiang/Documents/inwave-stack/ui/react-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/****  React Tiny FAB - Deric Cain<deric.cain@gmail.com>  *****/
import React from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var AB = function AB(a) {
  return React.createElement("button", _extends({
    type: "button"
  }, a, {
    className: "rtf--ab"
  }), a.children);
};

var MB = function MB(a) {
  return React.createElement("button", _extends({
    type: "button",
    className: "rtf--mb"
  }, a), a.children);
};

var Fab =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Fab, _React$Component);

  function Fab() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Fab);

    for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
      a[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Fab)).call.apply(_getPrototypeOf2, [this].concat(a))), _defineProperty(_assertThisInitialized(_this), "state", {
      open: !1
    }), _defineProperty(_assertThisInitialized(_this), "enter", function () {
      return "hover" === _this.props.event && _this.open();
    }), _defineProperty(_assertThisInitialized(_this), "leave", function () {
      return "hover" === _this.props.event && _this.close();
    }), _defineProperty(_assertThisInitialized(_this), "open", function () {
      return _this.setState({
        open: !0
      });
    }), _defineProperty(_assertThisInitialized(_this), "close", function () {
      return _this.setState({
        open: !1
      });
    }), _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      return "click" === _this.props.event ? _this.state.open ? _this.close() : _this.open() : null;
    }), _defineProperty(_assertThisInitialized(_this), "actionOnClick", function (a) {
      _this.setState({
        open: !1
      }, function () {
        setTimeout(function () {
          a();
        }, 1);
      });
    });
    return _this;
  }

  _createClass(Fab, [{
    key: "rc",
    value: function rc() {
      var _this2 = this;

      var _this$props = this.props,
          a = _this$props.children,
          b = _this$props.position,
          c = this.state.open;
      return 6 < React.Children.count(a) && console.warn("react-tiny-fab only supports up to 6 action buttons"), React.Children.map(a, function (a, d) {
        return React.createElement("li", {
          className: "rtf--ab__c ".concat("top" in b ? "top" : "")
        }, React.cloneElement(a, _objectSpread({
          "data-testid": "action-button-".concat(d),
          "aria-label": a.props.text || "Menu button ".concat(d + 1),
          "aria-hidden": !c
        }, a.props, {
          onClick: function onClick() {
            return _this2.actionOnClick(a.props.onClick);
          }
        })), a.props.text && React.createElement("span", {
          className: "right" in b ? "right" : "",
          "aria-hidden": !c
        }, a.props.text));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          a = _this$props2.position,
          b = _this$props2.icon,
          c = _this$props2.mainButtonStyles;
      return React.createElement("ul", {
        onMouseEnter: this.enter,
        onMouseLeave: this.leave,
        className: "rtf ".concat(this.state.open ? "open" : "closed"),
        style: a
      }, React.createElement("li", {
        className: "rtf--mb__c"
      }, React.createElement(MB, {
        onClick: this.toggle,
        style: c,
        role: "button",
        "aria-label": "Floating menu",
        tabIndex: "0"
      }, b), React.createElement("ul", null, this.rc())));
    }
  }]);

  return Fab;
}(React.Component);

_defineProperty(Fab, "defaultProps", {
  position: {
    bottom: 0,
    right: 0
  },
  event: "hover"
});

export { MB, Fab, AB as Action };